<template>
  <a-button
    type="text"
    @click="
      handleShowModal();
      $emit('click');
    "
    :disabled="itemresult.status === 2"
  >
    <template #icon>
      <PlusOutlined type="link" size="small" @click="handleShowModal" />
    </template>

    Agregar nuevo motivo
  </a-button>

  <a-drawer
    :visible="visible"
    width="400px"
    :mask-closable="false"
    centered
    :closable="false"
    :keyboard="false"
    @close="handleConfirmationClose"
  >
    <div class="container__title">
      <div>
        <span class="title__drawer">Agregar nuevo motivo</span>
        <a-tooltip>
          <template #title
            >Los motivos pertenecen a un resultado y brindan detalles más específicos de la llamada
            o interacción. Por ejemplo, para un resultado “Contact con titular de la línea”, puedes
            crear un motivo “Solicita volver a llamar”.</template
          >
          <InfoCircleOutlined />
        </a-tooltip>
      </div>
      <CloseOutlined @click="handleConfirmationClose" />
    </div>
    <div class="title">
      <div class="group">
        <h4>Grupo:</h4>
        <h5>{{ itemgroup.name }}</h5>
      </div>
      <div class="result">
        <h4>Resultado:</h4>
        <h5>{{ itemresult.name }}</h5>
      </div>
    </div>

    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="Nombre del motivo" name="name">
        <a-input v-model:value="formState.name" placeholder="Escribir nombre del motivo aquí..." />
      </a-form-item>

      <a-form-item name="code">
        <template #label>
          <span class="label">
            Código de integración
            <a-tooltip>
              <template v-slot:title>
                Código de identificación para exportaciones o integraciones
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
      </a-form-item>
    </a-form>

    <fixed-footer
      confirmText="Agregar motivo"
      @onCancel="handleCancel"
      @onConfirm="handleOk"
      cancelText="Cancelar"
    />
  </a-drawer>
</template>

<script>
import {
  InfoCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons-vue";
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
    FixedFooter,
    PlusOutlined,
    CloseOutlined,
  },
  props: {
    itemgroup: {
      required: true,
      type: Object,
    },
    itemresult: {
      required: true,
      type: Object,
    },
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      name: "",
      code: "",
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
    };

    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        this.$emit("push", {
          ...values,
          status: 1,
          children: [],
          type: "motive",
          is_expanded: true,
          group: this.itemgroup.id,
          order: this.itemresult.order + "." + (this.itemresult.children.length + 1),
          result: this.itemresult.id,
        });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.result
  margin-left: 28px
  margin-top: 18px

.title
  margin-bottom: 24px

.link
  text-decoration: underline

.title__drawer
  margin-right: 5px
  font-size: 16px
  font-weight: 600

.container__title
  height: 34px
  border-bottom: 1px solid #D4D4D4
  display: flex
  justify-content: space-between
  margin-bottom: 20px
  margin-top: -5px
</style>
